import CommonApp from '../../app.js';
import birthdayPickerTemplate from './birthday-picker.html';
import {configManager} from '../../../util/config-manager/config-manager.js';
import {AccountConfigManager} from '../../../util/config-manager/AccountConfigManager.js';
import {userProfileManager} from '../../../util/user-profile-manager.js';
import {strings} from '../../../util/strings.js';

var BirthdayPicker = function() {
    return {
        scope: {
            month: '=',
            day: '=',
            year: '=',
            countryCode: '=',
            language: '=',
            validDateCheck: '=',
            isSubmitted: '=',
            format: '=?'
        },
        controller: BirthdayPickerController,
        controllerAs: 'ctrl',
        bindToController: true,
        template: birthdayPickerTemplate
    };
};

var BirthdayPickerController = function($scope, birthdayFactory, strings, configManager, AccountConfigManager) {
    var self = this;
    var moment;
    var accountConfigManager = AccountConfigManager.getConfig(configManager);
    self.birthdayFactory = birthdayFactory;
    self.monthsList = birthdayFactory.getMonths();
    self.daysList = birthdayFactory.getDaysListDefault();
    moment = require('moment');
    self.ageLimit = accountConfigManager.site.minAge;
    self.errorMessage = strings.get('tdc_birthDateErrorMsg');
    self.ageErrorMessage = strings.get('tdc_minimumAgeText');
    self.error = false;
    var locales = userProfileManager.getPageLocaleVal();
    $scope.yearsList = null;

    self.init = function() {
        self.error = false;
        $scope.yearsList = birthdayFactory.getYears(self.ageLimit);
        $scope.$watch(self.getMonth.bind(this), self.getDaysList.bind(this));
    };

    self.getMonth = function() {
        return self.month;
    };

    self.getDaysList = function(monthCode) {
        if (!monthCode || monthCode === 'MM') {
            monthCode = 1;
        }
        self.daysList = birthdayFactory.getDaysForMonth(monthCode);
        self.leapYearValidation();
    };

    self.checkDate = function() {
        var currentDate = new Date();
        var selectedDate = new Date(self.year, self.month - 1, self.day);
        self.validAgeDate = new Date(currentDate.getFullYear() - self.ageLimit, currentDate.getMonth(),
            currentDate.getDate());
        if ((!self.day || self.day === 'DD')
            || (!self.month || self.month === 'MM')
            || (!self.year || self.year === 'YYYY')
            || (selectedDate > self.validAgeDate)) {
            self.error = true;
            angular.element(document).find('.year').addClass('red-border');
            return;
        }
    };
    self.checkFocus = function() {
        self.error = false;
        angular.element(document).find('.year').removeClass('red-border');
        return;
    };

    /**
     * checks to see if date is valid
     * @param {String} str
     * @return {boolean}
     */
    function isValidDate(str) {
        var d = moment(str, 'MM/DD/YYYY');
        if (d == null || !d.isValid()) return false;

        return str.indexOf(d.format('M-D-YYYY')) >= 0 || str.indexOf(d.format('MM-DD-YYYY')) >= 0
            || str.indexOf(d.format('M-D-YY')) >= 0 || str.indexOf(d.format('MM-DD-YY')) >= 0;
    }

    self.leapYearValidation = function() {
        if (self.year % 4 !== 0 && self.month == 2 && self.day == 29) {
            self.error = true;
            return;
        }
        // minimum age check
        var currentDate = new Date();
        var selectedDate = new Date(self.year, self.month - 1, self.day);
        self.validAgeDate = new Date(currentDate.getFullYear() - self.ageLimit, currentDate.getMonth(),
            currentDate.getDate());
        if (selectedDate > self.validAgeDate) {
            self.ageerror = true;
            self.validDateCheck = true;
            return;
        } else {
            self.ageerror = false;
        }

        if (!isValidDate(self.month + '-' + self.day + '-' + self.year)) {
            if (self.month.length > 0 && self.day.length > 0 && self.year.length > 0) {
                self.error = true;
                self.validDateCheck = true;
                return;
            }
        }
        self.error = false;
        if (self.month && self.day && self.year) {
            self.validDateCheck = false;
        }
    };
};

CommonApp.module.service('configManager', configManager);
CommonApp.module.service('AccountConfigManager', AccountConfigManager);
CommonApp.module.service('strings', strings);

BirthdayPickerController.$inject = ['$scope', 'birthdayFactory', 'strings', 'configManager', 'AccountConfigManager'];

CommonApp.module.controller('birthdayPickerController', BirthdayPickerController);

CommonApp.module.directive('nsBirthdayPicker', BirthdayPicker);




//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/birthday/birthday-picker.js
// module id = 48
// module chunks = 0